import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables', { supabaseUrl: !!supabaseUrl, supabaseAnonKey: !!supabaseAnonKey });
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'vetai.auth.token',
  },
});

/** Força limpeza completa da sessão quando o refresh token é inválido */
export async function forceClearSession(): Promise<void> {
  try {
    await supabase.auth.signOut({ scope: 'global' });
  } catch {
    // ignore
  }
  try {
    localStorage.removeItem('user');
    localStorage.removeItem('clinic_id');
    localStorage.removeItem('auth_user_id');
    localStorage.removeItem('vetai.auth.token');
    sessionStorage.removeItem('just_logged_out');
  } catch {
    // ignore
  }
}

/** Captura erros de refresh token não tratados e força logout limpo */
function isRefreshTokenError(err: unknown): boolean {
  if (!err) return false;
  const msg = String(
    (err as Error)?.message || (err as { errorMessage?: string })?.errorMessage || ''
  );
  return msg.includes('Invalid Refresh Token') || msg.includes('Refresh Token Not Found');
}

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (isRefreshTokenError(event.reason)) {
      event.preventDefault();
      forceClearSession().then(() => {
        window.location.reload();
      });
    }
  });
}

